import React, { FC } from "react";
import { OverlayTrigger, Tooltip as ReactstrapTooltip } from "react-bootstrap";
import { IToltip } from "./Tooptip.types";

const Tooltip: FC<IToltip> = ({ children, message, placement = "top" }) => {
  return (
    <>
      <OverlayTrigger
        key={placement}
        placement={placement}
        overlay={
          <ReactstrapTooltip
            id={`tooltip-${placement}`}
            style={{ zIndex: message ? 10000000 : -10 }}
          >
            {message}
          </ReactstrapTooltip>
        }
      >
        {children}
      </OverlayTrigger>
    </>
  );
};

export default Tooltip;
